<script setup lang="ts">
/**
 * A chart, drawn from figures typed into the report, flowing with the text.
 *
 * The drawing is shared with a chart placed freely on a page (see
 * `ChartCanvas.vue`); this only gives it its height and its caption.
 */
import ChartCanvas from '@/components/charts/ChartCanvas.vue'
import type { ChartSection } from '@/domain/section'

defineProps<{ section: ChartSection }>()
</script>

<template>
  <figure class="chart">
    <div class="chart__frame" :style="{ height: `${section.height}mm` }">
      <ChartCanvas :chart="section" :owner="section.id" />
    </div>
    <figcaption v-if="section.caption" class="page-caption">{{ section.caption }}</figcaption>
  </figure>
</template>

<style scoped>
.chart {
  margin: 1em 0 1.2em;
}

.chart__frame {
  position: relative;
  width: 100%;
}
</style>
